module.exports = __webpack_public_path__ + "img/ic_cuf.2cb23750.svg";